const KG_PER_LB = 0.453592; // 1 lb = 0.453592 kg
const LB_PER_KG = 2.20462; // 1 kg = 2.20462 lbs

// precision constants for medical accuracy
const WEIGHT_DECIMAL_PRECISION = 5; // High precision for internal calculations to avoid cascading rounding errors

export const lbsToKg = (lbs) => {
  return lbs * KG_PER_LB;
};

export const kgToLbs = (kg) => {
  return kg * LB_PER_KG;
};

export const getWeightInKg = (weight, unit) => {
  if (unit === "lbs") {
    return lbsToKg(Number(weight));
  }
  return Number(weight);
};

/**
 * Converts weight from one unit to another
 * @param {number} weight - The weight value to convert
 * @param {string} fromUnit - The current unit ("kg" or "lbs")
 * @param {string} toUnit - The target unit ("kg" or "lbs")
 * @param {number} precision - Decimal precision (default: 1)
 * @returns {number} Converted weight value
 */
export const convertWeight = (weight, fromUnit, toUnit, precision = WEIGHT_DECIMAL_PRECISION) => {
  if (fromUnit === toUnit) {
    return Number(weight);
  }

  let converted;
  if (fromUnit === "kg" && toUnit === "lbs") {
    converted = kgToLbs(Number(weight));
  } else if (fromUnit === "lbs" && toUnit === "kg") {
    converted = lbsToKg(Number(weight));
  } else {
    return Number(weight); // fallback
  }

  if (Number.isInteger(precision) && precision >= 0) {
    return Number(converted.toFixed(precision));
  }
  return converted;
};
